import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const CarIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M36.8333 23.8333H41.1667C42.3159 23.8333 43.4181 24.2899 44.2308 25.1025C45.0435 25.9152 45.5 27.0174 45.5 28.1667V32.5C45.5 33.0746 45.2717 33.6257 44.8654 34.0321C44.4591 34.4384 43.908 34.6667 43.3333 34.6667H40.0833M36.8333 23.8333H22.75M36.8333 23.8333L31.5965 15.1038C31.2115 14.4622 30.6669 13.9311 30.0157 13.5625C29.3645 13.1938 28.629 13 27.8807 13H22.75M40.0833 34.6667C40.0833 35.8159 39.6268 36.9181 38.8141 37.7308C38.0015 38.5435 36.8993 39 35.75 39C34.6007 39 33.4985 38.5435 32.6859 37.7308C31.8732 36.9181 31.4167 35.8159 31.4167 34.6667M40.0833 34.6667C40.0833 33.5174 39.6268 32.4152 38.8141 31.6025C38.0015 30.7899 36.8993 30.3333 35.75 30.3333C34.6007 30.3333 33.4985 30.7899 32.6859 31.6025C31.8732 32.4152 31.4167 33.5174 31.4167 34.6667M22.75 23.8333V13M22.75 23.8333H10.8333M22.75 13H16.5533C15.5512 12.9996 14.5799 13.3466 13.8048 13.9818C13.0297 14.617 12.4988 15.5013 12.3023 16.484L10.8333 23.8333M10.8333 23.8333C9.68406 23.8333 8.58186 24.2899 7.7692 25.1025C6.95655 25.9152 6.5 27.0174 6.5 28.1667V32.5C6.5 33.0746 6.72827 33.6257 7.1346 34.0321C7.54093 34.4384 8.09203 34.6667 8.66667 34.6667H11.9167M11.9167 34.6667C11.9167 35.8159 12.3732 36.9181 13.1859 37.7308C13.9985 38.5435 15.1007 39 16.25 39C17.3993 39 18.5015 38.5435 19.3141 37.7308C20.1268 36.9181 20.5833 35.8159 20.5833 34.6667M11.9167 34.6667C11.9167 33.5174 12.3732 32.4152 13.1859 31.6025C13.9985 30.7899 15.1007 30.3333 16.25 30.3333C17.3993 30.3333 18.5015 30.7899 19.3141 31.6025C20.1268 32.4152 20.5833 33.5174 20.5833 34.6667M20.5833 34.6667H31.4167"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </StyledSvgIcon>
);
export default CarIcon;

CarIcon.propTypes = customIconsPropTypes;
